<template>
	<div class="content">
		<headerTop></headerTop>
		<div class="swiperImg" :style="{backgroundImage:'url('+$index.addurl(img)+')'}"></div>
		<!-- 发展历程 -->
		<div class="center page-content flexbetween" :style="{animation:animation}">
			<div class="left">
				<div class="leftD">
					<div class="leftD_child" v-for="(item,index) in aboutLists" @click="todetail(item.id)">{{item.name}}</div>
				</div>
			</div>
			<div class="right">
				<div class="child" v-html="contents"></div>
				<div class="prosss">
					<div class="line">
						<div class="child" v-for="item in list.length"></div>
					</div>
					<div class="list flexaround" v-for="(item,index) in list">
						<div class="left flexleft">
							<div class="txt" :class="index%2!=0?'leftCol':''">{{item.title}}</div>
							<div class="time" :class="index%2!=0?'leftCol':''">{{item.date}}</div>
						</div>
						<div class="right flexleft">
							<div class="time" :class="index%2==0?'leftCol':''">{{item.date}}</div>
							<div class="txt" :class="index%2==0?'leftCol':''">{{item.title}}</div>
						</div>
					</div>
				</div>
			</div>
			
		</div> 
	</div>
</template>

<script>
	import router from "../../router";
	import headerTop from '../../components/headerTop.vue'
	export default{
		components: {
			headerTop
		},
		data(){
			return {
				contents:'',
				list:[],
				img:'',
				animation:'',
				aboutLists:[
					{
						name:'区位优势',
						id:8,
					},{
						name:'发展历程',
						id:9,
					},{
						name:'成果荣誉',
						id:10,
					},{
						name:'入驻机构',
						id:7,
					},
				],
			}
		},
		created() {
			this.animation = 'detail .4s linear forwards'
			this.getdata();
		},
		methods:{
			todetail(id){
				if(id == 7){
					this.$router.push({name:'aboutus'})
				}else if(id == 8){
					this.$router.push({name:'qwYoushi'})
				}else if(id == 9){
					this.$router.push({name:'fzLiucheng'})
				}else if(id == 10){
					this.$router.push({name:'cgRongyu'})
				}
			},
			getdata(){
				let _this = this;
				_this.$api.user.courseList().then(res => {
					if(res.code == 1){
						_this.contents = res.data.content;
						_this.list = res.data.list;
						_this.img = res.data.background_img;
					}
				})
			},
			
		},
		
	}
</script>
<style scoped>
	.content{
		background-color: #1452DC;
		border-bottom: 1px solid #1452DC;
		/* overflow: hidden; */
	}
</style>
<style scoped lang="scss">
	.left{
		align-self: flex-start;
		position: sticky;
		top: 100px;
		.leftD{
			background-color: #fff;
			border-radius: 20px;
			padding: 14px 30px 6px;
			width: 8vw;
			align-self: flex-start;
			z-index: 100;
			background-color: rgba(207, 232, 252, 0.5);
			margin-right: 20px;
			.leftD_child{
				margin: 20px 0;
				padding-bottom: 10px;
				font-size: 16px;
				text-align: center;
				color: #333;
				border-bottom: 1px solid #fff;
			}
			.leftD_child:last-child{
				border: none;
			}
			.leftD_child:hover{
				cursor: pointer;
				color: #1452DC;
				animation: changeTab .2s linear forwards;
			}
		}
	}
	.swiperImg{
		max-width: 1920px;
		background-image: url('../../assets/page4/bg1.png');
		background-size: cover;
		background-position: center;
		position: relative;
		padding: 220px 0;
	}
	.center{
		min-height: 300px;
		margin: 0 auto 100px;
		background-color: #fff;
		padding: 80px 120px 60px 60px;
		border-radius: 30px;
		position: relative;
		top: -80px;
		.page{
			margin: auto;
			display: flex;
			justify-content: center;
		}
		.anliList{
			flex-wrap: wrap;
			.alchild{
				width: 31.6%;
				margin: 0 10px 30px;
				opacity: 0;
				.img{
					width: 410px;
					height: 180px;
					img{
						width: 100%;
						height: 100%;
					}
				}
				.title{
					font-size: 18px;
					color: #333;
				}
				.time{
					font-size: 12px;
					color: #eee;
					margin: 0 10px;
					padding: 0 10px;
				}
			}
		}
		.prosss{
			margin: auto;
			position: relative;
			.leftCol{
				opacity: 0;
				// color: #fff !important;
			}
			.line{
				width: 2px;
				position: absolute;
				left: 50%;
				background-color: #1452DC;
				.child{
					width: 10px;
					height: 10px;
					padding: 6px;
					background-color: #fff;
					border-radius: 50%;
					border: 6px solid #1452DC;
					position: relative;
					left: -10px;
					margin: 50px 0;
				}
				.child:first-child{
					margin: 0 0 50px;
				}
				.child:last-child{
					margin: 50px 0 0;
				}
				
			}
			.list{
				
				position: relative;
				margin: 50px 100px;
				.left{
					flex: 1;
					padding-right: 20px;
					align-items: flex-start;
					.txt{
						flex:1;
						height: 20px;
						font-size: 16px;
						color: #333;
						margin: 0 10px;
						text-align: right;
					}
					.time{
						font-size: 16px;
						color: #333;
					}
				}
				.leftCol{
					color: red;
				}
				.right{
					flex: 1;
					padding-left: 22px;
					align-items: flex-start;
					.txt{
						flex:1; 
						height: 20px;
						font-size: 16px;
						color: #333;
						margin: 0 10px;
						
					}
					.time{
						font-size: 16px;
						color: #333;
					}
				}
				.childs{
					width: 20px;
					height:20px;
					margin: 30px ;
					border: 4px solid #1452DC;
					border-radius: 50%;
					position: relative;
					.line{
						position: absolute;
						bottom: -64px;
						left: 5px;
						background-color: #1452DC;
						width: 2px;
						height: 64px;
					}
				}
				.leftjj{
					.txt{
						font-size: 16px;
						color: #333;
						margin-right: 10px;
					}
					.time{
						font-size: 16px;
						color: #333;
					}
				}
				.rightjj{
					position: absolute;
					.txt{
						font-size: 16px;
						color: #333;
						margin-left: 20px;
					}
					.time{
						font-size: 16px;
						color: #333;
					}
				}
			}
			.list:last-child{
				.childs{
					.line{
						display: none;
					}
				}
			}
			.listt{
				margin-right: 150px;
			}
			.lists{
				margin-left: 152px;
			}
			
		}
		.child{
			.img{
				width: 45%;
				img{
					width: 100%;
					height: 100%;
				}
			}
			.txt{
				width: 45%;
				
			}
		}
	}
</style>


// WEBPACK FOOTER //
// fzLiucheng.vue?2e06c83b